import React from "react";
import BackgroundWide from "../../../src/assets/videos/background video/wide.mp4";
import BackgroundMobile from "../../../src/assets/videos/background video/LOW/mobile.mp4";
import "./update-page.styles.css"; // فایل استایل جداگانه برای تنظیمات بهتر
import SocialLinks from "../../components/drop-social-links/drop-social-links.component";

const UpdatePage = () => {
  return (
    <div className="update-page">
      {/* ویدئو پس‌زمینه نسخه دسکتاپ */}
      <video
        className="background-video desktop"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={BackgroundWide} type="video/mp4" />
      </video>

      {/* ویدئو پس‌زمینه نسخه موبایل */}
      <video
        className="background-video mobile"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={BackgroundMobile} type="video/mp4" />
      </video>

      {/* محتوای اصلی */}
      <div className="update-content">
        <h1>!سایت داره آپدیت میشه</h1>
        <p>
          زود برمی‌گردیم، اگه کاری داشتی می‌تونی از طریق پشتیبانی با ما در
          ارتباط باشی
        </p>

        {/* لینک‌های شبکه‌های اجتماعی */}
        <div className="social-link-update-page">
          <SocialLinks />
        </div>
      </div>
    </div>
  );
};

export default UpdatePage;
